import React, {useContext} from "react";
import {createUseStyles, useTheme} from "react-jss";
import TeamsUsers from "./host/TeamsUsers";
import HostActions from "./host/HostActions";
import HostState from "./host/HostState";
import Shared from "./Shared";
import HostBubbleContextProvider from "../contexts/HostBubbleContext";
import {HostBubble} from "./common/HostBubble";
import HostOptions from "./host/HostOptions";
import HostQuestions from "./host/HostQuestions";
import {EngageAppContext} from "../App";
import {HostLobby, TeamMode} from "engage-common/types";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import Tabs, {Tab, TabPanel} from "engage-client/components/Tabs";
import QuestionTiming from "./host/QuestionTiming";
import AppBar from "engage-client/components/AppBar";
import {Theme} from "engage-client/theme";
import {isUndefined} from "engage-common/utils";

const useStyles = createUseStyles<Theme>((theme) => ({
	host: {
		height: "100%",
		display:"flex",
		flexDirection: "column",
		backgroundColor: theme.color.background.main
	},
	panels: {
		flex: 1,
		display:"flex",
	},
	controlsGridItem: {
		flex: 1,
		padding: 16,
		display: "flex",
		flexDirection: "column",
	},
	sharedGridItem: {
		flex: 3,
		display: "flex",
		flexDirection: "column",
	},
	sharedContainer: {
		flex: 1,
		margin: 8,
		border: props => `1px solid ${props.paused ? theme.host.game.pauseColor : "black"}`,
		padding: 8,
	},
	titleContainer:  {
		marginTop: 16,
		display: "flex",
		alignItems: "center",
		paddingLeft: 16,
		textTransform: "uppercase",
	},
	screenIcon: {
		marginRight: 8
	},
	tabOverride: {
		minWidth: "unset"
	}
}));


export default function Host() {
	const {lobby, appState} = useContext(EngageAppContext.current);
	const theme = useTheme<Theme>();
	const classes = useStyles({paused: !isUndefined(appState.common.pauseMark)});
	const hostLobby = lobby as HostLobby;
	const [openTab, setOpenTab] = React.useState(0);

	const handleChange = (newTab: number) => {
		setOpenTab(newTab);
	};

	return (
		<div className={classes.host}>
			<HostBubbleContextProvider>
				<AppBar title={lobby?.title} joinCode={lobby?.id}><HostActions/></AppBar>
				<div className={classes.panels}>
					<div className={classes.controlsGridItem}>
						<Tabs value={openTab} onChange={handleChange}>
							<Tab label="Options"/>
							<Tab label="Timing"/>
							<Tab label="Questions"/>
							<Tab label={hostLobby.teamMode === TeamMode.Off ? "Users" : "Teams/Users"}/>
							<Tab label="State"/>
						</Tabs>
						<TabPanel value={openTab} index={0}>
							<HostOptions/>
						</TabPanel>
						<TabPanel value={openTab} index={1}>
							<QuestionTiming/>
						</TabPanel>
						<TabPanel value={openTab} index={2}>
							<HostQuestions/>
						</TabPanel>
						<TabPanel value={openTab} index={3}>
							<TeamsUsers hostLobby={hostLobby}/>
						</TabPanel>
						<TabPanel value={openTab} index={4}>
							<HostState/>
						</TabPanel>
					</div>
					<div className={classes.sharedGridItem}>
						<div className={classes.titleContainer}>
							<img src="/assets/icons/common/screen.png" className={classes.screenIcon} alt="Icon of a monitor"/>
							<DisplayText variant={TextVariant.s16reg} color="primary">Host's View</DisplayText>
							{appState.common.pauseMark &&
								<DisplayText variant={TextVariant.s16reg} color={theme.host.game.pauseColor}>&nbsp;- PAUSED</DisplayText>
							}
						</div>
						<div className={classes.sharedContainer}>
							<Shared showLogo={false} sharedDisplay={false}/>
						</div>
					</div>
				</div>
					<HostBubble />
			</HostBubbleContextProvider>
		</div>
	);
};